module.exports = __webpack_public_path__ + "static/media/Writing – 1.09395c2b.jpg";